module.exports = __webpack_public_path__ + "img/mastercard.737550c3.svg";